<template>
  <div class="g-wrapper">
    <div class="g-main">
      <img src="../assets/zuziTitle.png" alt="" class="u-pastTitle" />
    </div>

    <div class="g-reviewsList">
      <img src="../assets/zuzi.png" alt="" class="u-zuzi">
    </div>
    <img src="../assets/logo.png" alt="" class="u-logo">
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.g-main {
  padding-bottom: 20px;
}
.u-pastTitle {
  width: 501px;
  height: 118px;
  display: block;
  margin: 30px auto;
}
.g-reviewsList {
  width: 730px;
  padding: 55px 65px;
  box-sizing: border-box;
  background: #fff;
  margin: 0 auto;
  a {
    text-decoration: none;
    margin-bottom: 50px;
    display: block;
  }
}
.u-reviewImg {
  width: 600px;
  height: 300px;
  display: block;
}
.u-reviewTitle {
  width: 600px;
  height: 65px;
  background-image: linear-gradient(to right, #7e7e7e, #d0d0d0);
  margin-top: 5px;
  font-size: 30px;
  color: #fff;
  line-height: 65px;
  padding-left: 15px;
  box-sizing: border-box;
}
.u-zuzi {
    width: 612px;
    display: block;
    margin: 0 auto;
}
</style>